import BigNumber from "bignumber.js";

export function isLessThan(vala, valb) {
    // 创建 BigNumber 实例
    const number1 = new BigNumber(vala);
    const number2 = new BigNumber(valb);

    // 比较大小
    return number1.isLessThan(number2);
}
//减法
export function minus(vala, valb, num?: number) {
    const number1 = new BigNumber(vala);
    const number2 = new BigNumber(valb);

    return num
        ? number1.minus(number2).toFixed(Number(num))
        : number1.minus(number2).toFixed();
}

export function isGte(vala, valb) {
    // 创建 BigNumber 实例
    const number1 = new BigNumber(vala);
    const number2 = new BigNumber(valb);

    // 比较大小
    return number1.isGreaterThan(number2);
}

export function add(vala, valb, num?: number) {
    // 创建 BigNumber 实例
    const number1 = new BigNumber(vala);
    const number2 = new BigNumber(valb);

    // 比较大小
    return num
        ? number1.plus(number2).toFixed(Number(num))
        : number1.plus(number2).toFixed();
}

export function toNonExponential(num) {
    const m = num.toExponential().match(/\d(?:.(\d*))?e([+-]\d+)/);
    return num.toFixed(Math.max(0, (m[1] || "").length - m[2]));
}

export function times(vala, valb, num?: number) {
    // 创建 BigNumber 实例
    const number1 = new BigNumber(vala);
    const number2 = new BigNumber(valb);
    const val = num
        ? number1.multipliedBy(number2).toFixed(Number(num))
        : number1.multipliedBy(number2).toFixed();
    return val;
}
export function div(vala: any, valb: any, num?: number) {
    // 创建 BigNumber 实例
    const number1 = new BigNumber(vala);
    const number2 = new BigNumber(valb);
    if (number2.isEqualTo(BigNumber(0))) {
        return 0;
    }

    const val = num
        ? number1.dividedBy(number2).toFixed(Number(num))
        : number1.dividedBy(number2).toFixed();
    return val;
}

// 指数运算
export function exponentiatedBy(vala, valb) {
    const number1 = new BigNumber(vala);
    return number1.exponentiatedBy(valb).toFixed();
}

export function toFixed(val, num = 2) {
    console.log("vale____", val, num);
    const number1 = new BigNumber(val || "0");
    return number1.toFixed(Number(num));
}

export function Num(val, num) {
    val = new BigNumber(val || 0);
    return num ? val.toFixed(Number(num)) : val.toFixed();
}

export type Action = "div" | "times";

interface NumConvertDecimalOptions {
    decimal?: number;
    action: Action;
    stringify?: boolean;
    isInteger?: boolean;
}

export function convertDecimal(
    val: number | string,
    {
        decimal = 1,
        action,
        stringify = true,
        isInteger = false,
    }: NumConvertDecimalOptions
): string {
    const bigVal = new BigNumber(val);

    if (!bigVal.isFinite()) {
        return stringify ? new BigNumber(0).toFixed() : new BigNumber(0);
    }
    if (bigVal.isEqualTo(0)) {
        return stringify ? bigVal.toString() : bigVal.toFixed();
    }

    const factor = new BigNumber(10).pow(decimal);

    if (action === "div") {
        if (stringify) {
            return bigVal.dividedBy(factor).toFixed();
        } else {
            return bigVal.dividedBy(factor).toFixed();
        }
    } else if (action === "times") {
        if (stringify) {
            return isInteger
                ? bigVal.times(factor).integerValue().toFixed()
                : bigVal.times(factor).toFixed();
        } else {
            return isInteger
                ? bigVal.times(factor).integerValue()
                : bigVal.times(factor).toFixed();
        }
    } else {
        throw new Error("Invalid action specified. Use 'div' or 'times'.");
    }
}
